/**
 * Wialon API Service
 * Handles all proxy calls to Wialon via our backend
 */

import callAPI from '../ApiConfig';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Build auth query params for Wialon validation
 */
const getAuthParams = () => {
    return {
        username: cookies.get('user_name'),
        user_id: cookies.get('user_id'),
        account_id: cookies.get('account_id'),
        account_name: cookies.get('account_name'),
        sid: cookies.get('sid'),
        baseurl: cookies.get('baseUrl'),
    };
};

/**
 * Get account statistics (units count, active count)
 */
export const getAccountStats = async () => {
    const authParams = getAuthParams();
    return callAPI({
        route: `wialon_customers/account-stats`,
        method: 'GET',
        params: authParams,
    });
};

export default {
    getAccountStats,
};
